import axios from "axios";
const HOSTAPI = process.env.REACT_APP_BASE_URL;
const accessToken = sessionStorage.getItem('idToken');
export const setSequence = async (data: any, id: number): Promise<any> => {

    try {
        const response = await axios.put(`${HOSTAPI}/events/${id}/sequence`, data, {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            }
        });
        return response;
    } catch (error) {
        return error;
    }
};